var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"items":_vm.metodosPago,"label":"Elija método de pago","solo":"","flat":"","item-value":"id_sii","item-text":"nombre","return-object":"","outlined":""},on:{"change":_vm.onInput},model:{value:(_vm.seleccionado),callback:function ($$v) {_vm.seleccionado=$$v},expression:"seleccionado"}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }